export default class Glossary {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        jQuery( document ).ready(function() {
            if ($('.jet-alphabet-list').length > 0) {
                $('.jet-alphabet-list__input').each(function (i, e) {
                    let val = $(this).val();
                    let visible = false;
                    $('#glossary-grouped .letter').each(function (ii, ee) {
                        if ($(this).html() == val) {
                            visible = true;
                        }
                    })
                    !visible ? $(this).parents('.jet-alphabet-list__row').addClass('no-find') : '';
                })
            }
        });

    }


}


